import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useForm } from 'react-hook-form';
import { BiSave } from 'react-icons/bi';
import { IoArrowBackCircle } from 'react-icons/io5';
import { toast } from 'react-toastify';
import { testTargetPresenter, testTargetStore } from 'stores/root_store';
import {
  AddTestTarget,
  EditTestTarget,
  TestTargetDetail,
} from 'services/testTarget_services';
import { Autocomplete, TextField } from '@mui/material';
import * as rootStore from 'stores/root_store';

export type Routing = {
  stepCode: string;
  stepName: string;
};

export function createAddTestTarget() {
  return observer(() => {
    const navigate = useNavigate();

    // -------------------STATE--------------------------
    const [testTarget, setTestTarget] = useState<TestTargetDetail>({
      targetName: '',
      stepCode: '',
      stepName: '',
      actived: true,
      targetCode: 0,
      tolerance: '',
      isQualityIndiCation: false,
      requiredByWO: false,
      requiredByWOCard: true,
      standard: '',
    });

    const Style = {
      '.MuiOutlinedInput-root': {
        padding: 0,
        borderRadius: 0,
        fontSize: '13px',
      },
      '.MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
        fontSize: '13px',
      },
      '.MuiAutocomplete-inputRoot .MuiAutocomplete-input[aria-controls]': {
        fontSize: '13px',
      },

      ' .MuiOutlinedInput-notchedOutline': {
        borderColor: `${
          testTarget.stepCode ? 'focus:border-blue-500 caret-blue-600' : 'red'
        }`,
      },
    };

    // danh sách công đoạn -------
    const [listRouting, setListRouting] = useState<Routing[]>([]);

    // search keyword
    const [keyWordStepName, setKeyWordStepName] = useState('');

    const [defaultValue, setDefaultValue] = useState({
      stepCode: testTarget.stepCode || '',
      stepName: testTarget.stepName || '',
    });

    // Get the ID param from the URL
    const { TestTargetID = '' } = useParams();

    // Form validation-----------------------------------
    const { handleSubmit } = useForm<EditTestTarget>();

    const onEditSubmit = async (data: EditTestTarget) => {
      await testTargetPresenter.updateTestTarget(testTargetStore, {
        targetName: testTarget.targetName,
        stepCode: testTarget.stepCode,
        testTargetId: TestTargetID,
        actived: testTarget.actived,
        tolerance: testTarget.tolerance,
        isQualityIndiCation: testTarget.isQualityIndiCation,
        requiredByWO: testTarget.requiredByWO,
        requiredByWOCard: testTarget.requiredByWOCard,
        standard: testTarget.standard,
      });
      if (testTargetStore.updateResponse.isSuccess) {
        toast.success(testTargetStore.updateResponse.message);
        navigate(-1);
      } else {
        toast.error(testTargetStore.updateResponse.message);
      }
    };

    const onAddSubmit = async (data: AddTestTarget) => {
      await testTargetPresenter.createTestTarget(testTargetStore, {
        targetName: testTarget.targetName,
        stepCode: testTarget.stepCode,
        tolerance: testTarget.tolerance,
        isQualityIndiCation: testTarget.isQualityIndiCation,
        requiredByWO: testTarget.requiredByWO,
        requiredByWOCard: testTarget.requiredByWOCard,
        standard: testTarget.standard,
      });
      if (testTargetStore.createResponse.isSuccess) {
        toast.success(testTargetStore.createResponse.message);
        // navigate(-1);
      } else {
        toast.error(testTargetStore.createResponse.message);
      }
    };

    const handleChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
      setTestTarget({
        ...testTarget,
        [e.target.id]: e.target.value,
      });
    };
    const handleChangeStepName = (
      e: React.SyntheticEvent<Element, Event>,
      value: Routing | null
    ) => {
      if (value) {
        setTestTarget({
          ...testTarget,
          stepCode: value.stepCode,
          stepName: value.stepName,
        });
        setDefaultValue({
          stepCode: value.stepCode,
          stepName: value.stepName,
        });
      } else {
        setTestTarget({
          ...testTarget,
          stepCode: '',
          stepName: '',
        });
        setDefaultValue({
          stepCode: '',
          stepName: '',
        });
      }
    };
    // const handleChangeStepCode = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //   setTestTarget({
    //     ...testTarget,
    //     stepCode: e.target.value,
    //   });
    // };
    // const handleChangeActived = (e: React.ChangeEvent<HTMLInputElement>) => {
    //   setTestTarget({
    //     ...testTarget,
    //     actived: e.target.value,
    //   });
    // };

    // =========== get keyword stepName ==================
    const handleChangeKeyWordStepName = async (
      e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
      setKeyWordStepName(e.target.value);
      console.log(e.target.value);

      await rootStore.routingPresenter.getListRouting(
        rootStore.routingStore,
        e.target.value
      );
      setListRouting(rootStore.routingStore.routing.data);
    };

    // reset input
    const handleResetInput = () => {
      if (testTarget.targetName) {
        setTestTarget({
          targetName: '',
          stepCode: '',
          actived: false,
          targetCode: 0,
          tolerance: '',
        });
        navigate(-1);
      } else {
        navigate(-1);
      }
    };

    useEffect(() => {
      // gọi cụ thể 1 test target bằng id
      const callGetTestTargetByIDApi = async () => {
        await testTargetPresenter.getTestTargetById(
          testTargetStore,
          TestTargetID
        );
        setTestTarget({
          targetName: testTargetStore.testTargetByID.data?.targetName,
          stepCode: testTargetStore.testTargetByID.data?.stepCode,
          stepName: testTargetStore.testTargetByID.data?.stepName,
          actived: testTargetStore.testTargetByID.data?.actived,
          targetCode: testTargetStore.testTargetByID.data?.targetCode,
          tolerance: testTargetStore.testTargetByID.data?.tolerance,
          isQualityIndiCation:
            testTargetStore.testTargetByID.data?.isQualityIndiCation,
          requiredByWO: testTargetStore.testTargetByID.data?.requiredByWO,
          requiredByWOCard:
            testTargetStore.testTargetByID.data?.requiredByWOCard,
          standard: testTargetStore.testTargetByID.data?.standard,
        });
        setDefaultValue({
          stepCode: testTargetStore.testTargetByID.data?.stepCode || '',
          stepName: testTargetStore.testTargetByID.data?.stepName || '',
        });
      };
      if (TestTargetID) {
        callGetTestTargetByIDApi();
      }
    }, [TestTargetID]);

    // call list routing
    useEffect(() => {
      // lấy danh sách công đoạn
      const getListRouting = async () => {
        const listRouting = await rootStore.routingPresenter.getListRouting(
          rootStore.routingStore,
          keyWordStepName
        );
        if (listRouting) setListRouting(listRouting);
      };
      getListRouting();
    }, [keyWordStepName]);
const handleReload = ()=>{
  setTimeout(()=>{
    window.location.reload()
  },2000)
}
    return (
      <div className='w-full p-3.5'>
        {/* title - // Tiêu đề trang */}
        <form
          onSubmit={handleSubmit(TestTargetID ? onEditSubmit : onAddSubmit)}
        >
          <div className='w-full md:flex items-center mb-2 md:justify-between'>
            <div className='flex items-center'>
              <h3 className='text-md font-bold text-gray-800 uppercase'>
                {TestTargetID ? 'Chỉnh sửa' : 'Thêm mới '} chỉ tiêu kiểm tra
                theo công đoạn
              </h3>
              {/* nút back */}
              <span
                onClick={handleResetInput}
                className='flex items-center text-xs text-primary cursor-pointer ml-3 font-medium whitespace-nowrap'
              >
                <IoArrowBackCircle className='mr-2 text-base text-gray-500' />
                Quay lại
              </span>
            </div>
            {/* Nút lưu và lưu tiếp tục */}
            <div className='flex float-right my-2 md:my-0'>
              <button
                disabled={
                  testTarget.stepCode === '' || testTarget.targetName === ''
                }
                onClick={handleReload}
                className='flex items-center rounded-base bg-primary text-white text-default py-1 px-2.5 mr-3'
              >
                <BiSave className='text-base mr-0.5' />
                Lưu
              </button>
              {/* <button className='flex items-center rounded-base bg-primary text-white text-default py-1 px-2.5'>
                <BiSave className='text-base mr-0.5' />
                Lưu và tiếp tục
              </button> */}
            </div>
          </div>
          {/* Form thêm mới  */}
          <div className='w-full bg-white p-3.5 flex rounded mb-2 border border-neutral-300'>
            <div className='w-full lg:grid lg:grid-cols-1 flex flex-col gap-2'>
              {/*Mã chỉ tiêu  */}
              <div className='w-full sm:flex-row sm:items-center sm:grid sm:grid-cols-6 flex flex-col'>
                <label
                  htmlFor='targetCode'
                  className='col-span-2 font-medium text-default text-gray-700 sm:text-end'
                >
                  Mã chỉ tiêu
                </label>
                <input
                  readOnly
                  disabled
                  value={
                    testTarget.targetCode !== 0
                      ? `${testTarget.targetCode}`
                      : 'NEW'
                  }
                  type='text'
                  id='targetCode'
                  required
                  className='col-span-4 lg:col-span-3 text-gray-700 border border-gray-300 sm:ml-8 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600'
                />
              </div>
              {/* Tên chỉ tiêu */}
              <div className='w-full sm:flex-row sm:items-center sm:grid sm:grid-cols-6 flex flex-col'>
                <label
                  htmlFor='targetName'
                  className='col-span-2 font-medium text-default text-gray-700 sm:text-end'
                >
                  Tên chỉ tiêu
                </label>
                <input
                  onChange={handleChangeValue}
                  type='text'
                  id='targetName'
                  value={testTarget ? `${testTarget.targetName}` : ''}
                  className={`col-span-4 lg:col-span-3 text-gray-700 border border-gray-300 sm:ml-8 px-3 py-1.5 text-default flex-1 focus-visible:outline-none ${
                    testTarget.targetName
                      ? 'border-gray-300  focus:border-blue-500 caret-blue-600'
                      : 'border-red-600'
                  }`}
                />
              </div>
              {testTarget.targetName === '' && (
                <div className='w-full sm:flex-row sm:items-center sm:grid sm:grid-cols-6 flex flex-col'>
                  <div className='col-span-2'></div>
                  <p className='col-span-4 sm:ml-8  text-default text-red-500'>
                    vui lòng điền tên chỉ tiêu
                  </p>
                </div>
              )}
              {/* Sai số cho phép */}
              <div className='w-full sm:flex-row sm:items-center sm:grid sm:grid-cols-6 flex flex-col'>
                <label
                  htmlFor='tolerance'
                  className='col-span-2 font-medium text-default text-gray-700 sm:text-end'
                >
                  Sai số cho phép
                </label>
                <input
                  onChange={handleChangeValue}
                  type='text'
                  id='tolerance'
                  value={testTarget.tolerance ? `${testTarget.tolerance}` : ''}
                  className='col-span-4 lg:col-span-3 text-gray-700 border border-gray-300 sm:ml-8 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600'
                />
              </div>
              {/* Tiêu chuẩn kiểm tra */}
              <div className='w-full sm:flex-row sm:items-center sm:grid sm:grid-cols-6 flex flex-col'>
                <label
                  htmlFor='tolerance'
                  className='col-span-2 font-medium text-default text-gray-700 sm:text-end'
                >
                  Tiêu chuẩn kiểm tra
                </label>
                <input
                  onChange={handleChangeValue}
                  type='text'
                  id='standard'
                  value={testTarget.standard ? `${testTarget.standard}` : ''}
                  className='col-span-4 lg:col-span-3 text-gray-700 border border-gray-300 sm:ml-8 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600'
                />
              </div>
              {/* Công đoạn */}
              <div className='w-full sm:flex-row sm:items-center sm:grid sm:grid-cols-6 flex flex-col'>
                <label
                  htmlFor='stepCode'
                  className='col-span-2 font-medium text-default text-gray-700 sm:text-end'
                >
                  Công đoạn
                </label>
                <Autocomplete
                  className={`col-span-4 lg:col-span-3 text-gray-700 border-gray-300 sm:ml-8 py-1.5 text-default flex-1 focus-visible:outline-none`}
                  id='stepName'
                  options={listRouting}
                  sx={Style}
                  classes={{ listbox: 'text-default' }}
                  filterOptions={(options, state) => options}
                  value={defaultValue}
                  getOptionLabel={(option) => option.stepName}
                  onChange={handleChangeStepName}
                  renderInput={(params) => (
                    <TextField
                      onChange={handleChangeKeyWordStepName}
                      {...params}
                      value={keyWordStepName}
                    />
                  )}
                />

                {/* <select
                  onChange={handleChangeStepCode}
                  value={testTarget.stepCode ? testTarget.stepCode : ''}
                  className='col-span-4 lg:col-span-3 text-gray-700 border border-gray-300 sm:ml-8 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600'
                >
                  <option className='' value='' disabled>
                    -- Chọn công đoạn --
                  </option>
                  {listRouting?.map((item) => {
                    return (
                      <option
                        key={item.stepCode}
                        value={item.stepCode}
                        // selected={testTarget.stepCode === item.stepCode}
                      >
                        {item.stepName}
                      </option>
                    );
                  })}
                </select> */}
              </div>
              {testTarget.stepCode === '' && (
                <div className='w-full sm:flex-row sm:items-center sm:grid sm:grid-cols-6 flex flex-col'>
                  <div className='col-span-2'></div>
                  <p className='col-span-4 sm:ml-8  text-default text-red-500'>
                    vui lòng chọn công đoạn
                  </p>
                </div>
              )}

              {/* Loại chỉ tiêu */}
              <div className='w-full sm:flex-row sm:items-center sm:grid sm:grid-cols-6 flex flex-col'>
                <label className='col-span-2 font-medium text-default text-gray-700 sm:text-end'>
                  Loại chỉ tiêu
                </label>
                <div className='col-span-4 lg:col-span-3 flex-1'>
                  <div className='flex col-span-2 sm:ml-8 py-1.5 text-default flex-1 '>
                    {/* hiệu lực */}
                    <div className='mr-5 flex items-center justify-center'>
                      <input
                        id='statusTarget'
                        checked={testTarget.isQualityIndiCation === true}
                        type='radio'
                        name='statusIsTarget'
                        onChange={() => {
                          setTestTarget({
                            ...testTarget,
                            isQualityIndiCation: true,
                          });
                        }}
                        className='mr-2'
                      />
                      <label htmlFor='statusTarget'>Chỉ tiêu định lượng</label>
                    </div>
                    {/* Đã hủy */}
                    <div className='mr-5 flex items-center justify-center'>
                      <input
                        id='unstatusTarget'
                        checked={testTarget.isQualityIndiCation === false}
                        type='radio'
                        name='statusIsTarget'
                        onChange={() => {
                          setTestTarget({
                            ...testTarget,
                            isQualityIndiCation: false,
                          });
                        }}
                        className='mr-2'
                      />
                      <label htmlFor='unstatusTarget'>Chỉ tiêu định tính</label>
                    </div>
                  </div>
                </div>
              </div>
              {/* Bắt buộc kiểm tra theo lệnh */}
              <div className='w-full sm:flex-row sm:items-center sm:grid sm:grid-cols-6 flex flex-col'>
                <label className='col-span-2 font-medium text-default text-gray-700 sm:text-end'>
                  Bắt buộc kiểm tra theo lệnh
                </label>
                <div className='col-span-4 lg:col-span-3 flex-1'>
                  <div className='flex col-span-2 sm:ml-8 py-1.5 text-default flex-1 '>
                    <div className='mr-5 flex items-center justify-center'>
                      <input
                        id='statusRequiredByWO'
                        checked={testTarget.requiredByWO === true}
                        type='radio'
                        name='requiredByWO'
                        onChange={() => {
                          setTestTarget({
                            ...testTarget,
                            requiredByWO: true,
                          });
                        }}
                        className='mr-2'
                      />
                      <label htmlFor='statusRequiredByWO'>Có</label>
                    </div>
                    <div className='mr-5 flex items-center justify-center'>
                      <input
                        id='unStatusRequiredByWO'
                        checked={testTarget.requiredByWO === false}
                        type='radio'
                        name='requiredByWO'
                        onChange={() => {
                          setTestTarget({
                            ...testTarget,
                            requiredByWO: false,
                          });
                        }}
                        className='mr-2'
                      />
                      <label htmlFor='unStatusRequiredByWO'>Không</label>
                    </div>
                  </div>
                </div>
              </div>
              {/* Bắt buộc kiểm tra theo thẻ treo */}
              <div className='w-full sm:flex-row sm:items-center sm:grid sm:grid-cols-6 flex flex-col'>
                <label className='col-span-2 font-medium text-default text-gray-700 sm:text-end'>
                  Bắt buộc kiểm tra theo thẻ treo
                </label>
                <div className='col-span-4 lg:col-span-3 flex-1'>
                  <div className='flex col-span-2 sm:ml-8 py-1.5 text-default flex-1 '>
                    <div className='mr-5 flex items-center justify-center'>
                      <input
                        id='statusRequiredByWOCard'
                        checked={testTarget.requiredByWOCard === true}
                        type='radio'
                        name='requiredByWOCard'
                        onChange={() => {
                          setTestTarget({
                            ...testTarget,
                            requiredByWOCard: true,
                          });
                        }}
                        className='mr-2'
                      />
                      <label htmlFor='statusRequiredByWOCard'>Có</label>
                    </div>
                    <div className='mr-5 flex items-center justify-center'>
                      <input
                        id='unStatusRequiredByWOCard'
                        checked={testTarget.requiredByWOCard === false}
                        type='radio'
                        name='requiredByWOCard'
                        onChange={() => {
                          setTestTarget({
                            ...testTarget,
                            requiredByWOCard: false,
                          });
                        }}
                        className='mr-2'
                      />
                      <label htmlFor='unStatusRequiredByWOCard'>Không</label>
                    </div>
                  </div>
                </div>
              </div>
              {/* Trạng thái */}
              <div className='w-full sm:flex-row sm:items-center sm:grid sm:grid-cols-6 flex flex-col'>
                <label className='col-span-2 font-medium text-default text-gray-700 sm:text-end'>
                  Trạng thái
                </label>
                <div className='col-span-4 lg:col-span-3 flex-1'>
                  <div className='flex sm:ml-8 py-1.5 text-default flex-1 '>
                    {/* hiệu lực */}
                    <div className='mr-5 flex items-center justify-center'>
                      <input
                        id='active'
                        checked={testTarget.actived === true}
                        type='radio'
                        name='actived'
                        onChange={() => {
                          setTestTarget({ ...testTarget, actived: true });
                        }}
                        className='mr-2'
                      />
                      <label htmlFor='active'>Hiệu lực</label>
                    </div>
                    {/* Đã hủy */}
                    <div className='mr-5 flex items-center justify-center'>
                      <input
                        id='unactive'
                        checked={testTarget.actived === false}
                        type='radio'
                        name='actived'
                        onChange={() => {
                          setTestTarget({ ...testTarget, actived: false });
                        }}
                        className='mr-2'
                      />
                      <label htmlFor='unactive'>Đã hủy</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  });
}
